import { Storybook } from "@tento-ui/ui/storybook";
import { CoreRegistry } from "./core-registry";
import { StorybookContainer } from "./storybook-container";
import { StorybookTabItem } from "./examples";

// The catalogue has two modes. Core sections come from `CoreRegistry`, which
// the std- charter fills; the page only renders them. Extension sections are
// the hand-written product tabs in `examples.ts`, which is the right home for
// them: their grouping is a product judgment nothing on disk could infer.
export namespace Catalogue {
  export type Mode = "core" | "ext";
  export type Section = StorybookContainer.Section;
  export type Model = { core: Section[]; extensions: Section[] };

  export function build(): Model {
    const core: Section[] = CoreRegistry.sections();

    // Lint rule 9 forbids a core story in `examples.ts`; the filter is the
    // page's own copy of that rule, so a slip shows once, not twice.
    const extensions: Section[] = StorybookTabItem.ALL.map((t) => ({
      id: t.id,
      label: t.label,
      gridConfig: t.gridConfig,
      items: t.items.filter((s: Storybook) => s.tags().length === 0),
      gaps: [],
    }));

    return { core, extensions };
  }
}
